import { createAction } from '@reduxjs/toolkit'

import { KpiOptionObject } from 'types/GlobalKpiOption'

// tryCreateKpiOption
export const create = createAction('create_kpi_option')
export const createSuccess = createAction<KpiOptionObject>(
  'create_kpi_option_success'
)
export const createFailed = createAction('create_kpi_option_failed')

// tryUpdateKpiOption
export const update = createAction('update_kpi_option')
export const updateSuccess = createAction<{
  data: KpiOptionObject
  skipFetchData?: boolean
}>('update_kpi_option_success')
export const updateFailed = createAction('update_kpi_option_failed')

// tryDeleteKpiOption
export const destroy = createAction('delete_kpi_option')
export const destroySuccess = createAction<{
  id: string
  widgetId: string
}>('delete_kpi_option_success')
export const destroyFailed = createAction('delete_kpi_option_failed')
